import { render, staticRenderFns } from "./OnboardingIntegrationCustomEmail.vue?vue&type=template&id=6ae579ce&scoped=true&"
import script from "./OnboardingIntegrationCustomEmail.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntegrationCustomEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae579ce",
  null
  
)

export default component.exports